import { Button } from "@mantine/core";
import { IconPaperclip, IconPlus } from "@tabler/icons-react";
import { useController } from "react-hook-form";

import { useDispatch } from "../../../redux/hooks";
import { setBodyPartModalData } from "../../../redux/slices/generatorFeaturesSlice";
import { Flex, StyledActionIcon } from "../../../styled";
import CustomInput from "../../CustomInput/CustomInput";
import { type BodyPart } from "./BodyPart.model";
import BodyPartList from "./BodyPartList";

interface Props {
  value: { text: string; data: BodyPart[] };
  id: string;
}

const BodyPartInput = ({ value, id }: Props) => {
  const dispatch = useDispatch();
  const defaultData = Array.isArray(value.data) ? value.data : [];
  const { field: partsField } = useController({
    name: `${id}.data`,
    defaultValue: defaultData,
  });
  const handleClick = () => {
    dispatch(
      setBodyPartModalData({ value: partsField.value, inputId: `${id}.data` }),
    );
  };
  return (
    <Flex align="center" gap={15} justify="space-between">
      <Flex gap={15} w="100%">
        <CustomInput
          value={value.text ?? ""}
          id={`${id}.text`}
          prefix="Description"
          textarea
          miw={300}
        />
        <Flex
          direction="column"
          style={{ flexBasis: "100%", flexGrow: 1 }}
          gap={10}>
          <BodyPartList
            bodyParts={partsField.value}
            type="front"
            label="Front"
            inputId={`${id}.data`}
            viewable
          />
          <BodyPartList
            bodyParts={partsField.value}
            type="back"
            label="Back"
            inputId={`${id}.data`}
            viewable
          />
        </Flex>
      </Flex>

      <StyledActionIcon onClick={handleClick}>
        <IconPaperclip />
      </StyledActionIcon>
    </Flex>
  );
};
export default BodyPartInput;
